import { Table } from "antd";
import { useEffect, useState } from "react";
import { getProducts } from "~@/API/fake";
import { ProductType } from "~@/types/fake";
import { PageResponseType } from "~@/types/universal";
import { showTotal } from "~@/utils/helper";
const ProductList = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setData] = useState<PageResponseType<ProductType>>();
  const columns = [
    {
      title: "商品图片",
      dataIndex: "image",
      key: "image",
      render: (src: string) => (
        <img className="w-[30px] h-[30px] rounded-[4px]" src={src} alt="" />
      ),
    },
    {
      title: "商品",
      dataIndex: "productName",
      key: "productName",
    },
    {
      title: "库存",
      dataIndex: "stock",
      key: "stock",
    },
    {
      title: "价格",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "商品编号",
      dataIndex: "no",
      key: "no",
    },
    {
      title: "修改时间",
      dataIndex: "updateAt",
      key: "updateAt",
      render: (text: string) => text || "-",
    },
  ];

  useEffect(() => {
    getProducts({ currentPage: 1, pageSize: 10 }).then((res) => {
      console.log(res);
      if (res?.success) {
        setData(res.data);
      }
    });
  }, []);

  return (
    <>
      <Table
        rowKey="no"
        columns={columns}
        dataSource={[]}
        pagination={{ showTotal, size: "small", showSizeChanger: true }}
      />
    </>
  );
};

export default ProductList;
